// extracted by mini-css-extract-plugin
export default {"alert":"Alert-alert-_KgnQ","danger":"Alert-danger-nugZ_","info":"Alert-info-BFcpa","success":"Alert-success-DPVBw","warning":"Alert-warning-K7oQl"};